import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { usePortalNode } from '../hooks/usePortalNode';
import { PopupContext } from '../../popups/PopupContext';
import s from './PopperPortal.scss';

export interface Props {
  portalClassName?: string;
  children: React.ReactNode;
}

/** Simple wrapper to stick things into a portal */
const PopperPortal: React.FC<Props> = ({ portalClassName, children }) => {
  const { isInPopup } = useContext(PopupContext);
  const portalContainer = usePortalNode(
    'popper',
    classnames(
      isInPopup ? s['popup-portal'] : s['portal'],
      'popper-portal',
      portalClassName
    )
  );

  return portalContainer && ReactDOM.createPortal(children, portalContainer);
};
PopperPortal.displayName = 'PopperPortal';

export default PopperPortal;
